<template>
  <div class="text-muted">Doporučený počet osob: {{ peopleCount }}</div>
</template>


<script setup>
import {defineProps, computed, defineEmits} from 'vue'
import {getRequiredPeopleCount} from "@/common/functions"
const props = defineProps(['weight'])
const emit = defineEmits(['update:peopleCount'])
const peopleCount = computed(() => {
  const response = getRequiredPeopleCount(props.weight)
  emit('update:peopleCount', response)
  return response
})
</script>



<style scoped>
</style>